import { CameraGroupsDTO } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useCameraGroups(searchParams: string, enabled = true) {
  const url = `/v2/orm/camera_groups${searchParams ? `?${searchParams}` : ''}`;
  const request = new Request(url);

  return useAuthenticatedRequest<CameraGroupsDTO>(request, {
    queryKey: ['camera-groups', { searchParams }],
    enabled: enabled,
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
  });
}

export default useCameraGroups;
